"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "@/models/tags.model";
import { DataSetModel } from "@/models/dataset.model";
export let ShopModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.oldId = "";
    this.name = "";
    this.ebusiness = "";
    this.logo = "";
    this.ebusiness_platform_name_cn = "";
    this.marks = new TagsModel();
    this.users = new DataSetModel();
  }
};
ShopModel.model = "shop";
ShopModel = __decorateClass([
  Annotation.ModelMeta
], ShopModel);
export let ShopListModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    // shop_guid:string = "";
    this.shopId = "";
    // vd_guid:string = "";
    this.vdId = "";
    // ebusiness_type:string ="";
    this.ebusinessType = "";
    // name:string = "";
    this.shopName = "";
    this.marks = new TagsModel();
    this.id = "";
    // logo_url:string = "";
    this.logoUrl = "";
    // team_auth_count:number = 0;
    this.teamAuthCount = 0;
    // last_login_name?:string = "";
    this.lastLoginName = "";
    // last_login_time?:number = 0;
    this.lastLoginTime = 0;
    // ebusiness_platform_guid:string = "";
    this.ebusinessPlatformGuid = "";
    // shop_lock:boolean = false;
    this.shopLock = false;
    this.color = "";
    this.character = "";
    this.shopStatus = "";
    this.ip = "";
    this.ipAlias = "";
    this.regionDesc = "";
    this.account = "";
    this.users = new DataSetModel();
    // status:string = "";
    this.vdStatus = "";
  }
};
ShopListModel.model = "shop.model";
ShopListModel = __decorateClass([
  Annotation.ModelMeta
], ShopListModel);
export let ExtEbusinessModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.shop_ext_ebusiness_guid = "";
    this.ebusiness_guid = "";
    this.ebusiness_platform_guid = "";
    this.name = "";
    this.account = "";
    this.password = "";
    this.logo_url = "";
    this.lock_account = false;
    this.lockAccount = false;
    this.is_custom = false;
    this.url = "";
  }
};
ExtEbusinessModel.model = "shop.ext.ebusiness";
ExtEbusinessModel = __decorateClass([
  Annotation.ModelMeta
], ExtEbusinessModel);
export class ExtEbusinessProModel extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.shop_ext_ebusiness_guid = "";
    this.logo = "";
    this.logo_url = "";
    this.lockAccount = false;
    this.name = "";
    this.account = "";
    this.password = "";
    this.url = "";
    this.ebusiness_id = "";
    this.ebusiness_platform_guid = "";
    this.is_custom = false;
    this.ebusiness = new EbusinessProModel();
  }
}
export class EbusinessProModel extends CoreModel {
  constructor() {
    super(...arguments);
    this.model = "";
    this.id = "";
    this.name = "";
    this.url = "";
    this.account = "";
    this.password = "";
    this.lockAccount = false;
  }
}
export let ShopModelPro = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.shopOldId = "";
    this.vd = new VDmodel();
    this.name = "";
    this.ebusiness = new EbusinessModel();
    this.ebusinessPlatform = new EbusinessPlatformModel();
    this.account = "";
    this.address = "";
    this.region = "";
    this.authUserCount = 0;
    this.lastlogin = new LastLoginModel();
    this.lock = false;
    this.remark = "";
    this.icon = new IconModel();
    this.marks = new TagsModel();
    this.status = "";
    this.filesCount = 0;
  }
};
ShopModelPro.model = "shop";
ShopModelPro = __decorateClass([
  Annotation.ModelMeta
], ShopModelPro);
export let VDmodel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.oldId = "";
    this.status = "";
    this.canUseSeconds = 0;
    this.marks = new TagsModel();
  }
};
VDmodel.model = "vd";
VDmodel = __decorateClass([
  Annotation.ModelMeta
], VDmodel);
export let EbusinessModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.logo = "";
    this.type = "";
  }
};
EbusinessModel.model = "ebusiness";
EbusinessModel = __decorateClass([
  Annotation.ModelMeta
], EbusinessModel);
export let EbusinessPlatformModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
EbusinessPlatformModel.model = "ebusinessPlatform";
EbusinessPlatformModel = __decorateClass([
  Annotation.ModelMeta
], EbusinessPlatformModel);
export let LastLoginModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.time = 0;
  }
};
LastLoginModel.model = "lastlogin";
LastLoginModel = __decorateClass([
  Annotation.ModelMeta
], LastLoginModel);
export let IconModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.color = "";
    this.character = "";
  }
};
IconModel.model = "icon";
IconModel = __decorateClass([
  Annotation.ModelMeta
], IconModel);
export let ShopBindModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.shopOldId = "";
    this.name = "";
    this.vd = new VDmodel();
  }
};
ShopBindModel.model = "shop.bind";
ShopBindModel = __decorateClass([
  Annotation.ModelMeta
], ShopBindModel);
